import { axiosInstance } from ".."

const transectionList = async (querry) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/transaction?${querry}`).then((res) => { 
            console.log(res)
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default transectionList;